<template>
  <ModalDialog
    ref="dialog"
    id="mydialog"
    @ok="onSave"
    @cancel="cancelModal"
    :maxWidth="360"
    :showCancelIcon="true"
    :title="title"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :displayOkButton="true"
    :labelOk="labelOk"
  >
    <div ref="mydialog" class="dlg-choice">
      <form>
        <div class="form-group">
          <div class="task-title">
            <InputText
              id="title"
              :label="$t('addTaksDialog.title') + ' *'"
              :placeholder="$t('addTaksDialog.title')"
              v-model="task.title"
            />
            <span
              class="text-danger"
              v-if="invalidTitle && task.title.length == 0"
            >
              {{ $t('addTaksDialog.taskTitleRequired') }}
            </span>
          </div>
          <div class="task-description mt-2">
            <InputText
              :label="$t('options.lbDescription')"
              :placeholder="$t('options.phDescription')"
              v-model="task.description"
            />
            <span class="text-size-10 pt-0 toggle-description">
              {{ getDescriptionLength }}
            </span>
          </div>
          <div v-if="!editMode" class="nmb-copies mt-2 d-flex">
            {{$t('tasks.howMany')}}
            <input
              class="tasks-cont ml-3"
              type="number"
              :value="task.resource_count"
              @input="(event) => (task.resource_count = event.target.value)"
              min="1"
            />
          </div>
        </div>
      </form>
    </div>
  </ModalDialog>
</template>
<script>
import { renderMixin } from '../mixins/RenderMixins';
import { constants } from '@/shared/constant';
//import { faTachometerSlow } from '@fortawesome/pro-light-svg-icons';

function Task() {
  this.id = null;
  this.title = '';
  this.decsription = '';
  this.resource_count = 1;
  this.poll_id = null;
}

export default {
  name: 'ModalAddTaskDialog',

  data() {
    return {
      posX: 0,
      posY: 0,

      task: new Task(),
      invalidTitle: false,
      modalDialog: null,
    };
  },
  props: ['editedChoice', 'editMode', 'selectedTask'],
  watch: {
    selectedTask: function (newVal) {
      // watch it
      if (newVal) {
        this.task = { ...newVal };
      } else {
        this.task = new Task();
      }
    },
  },
  mixins: [renderMixin],
  computed: {
    title() {
      return this.editMode
        ? this.$t('addTaksDialog.headlineEditTask')
        : this.$t('addTaksDialog.headlineAddTask');
    },

    labelOk() {
      if (this.editMode) return this.$t('addTaksDialog.btnSave');
      return this.$t('addTaksDialog.btnAddJobs');
    },

    dlgStyle() {
      const dlgWidth = 360;

      const dlgHeight = 360;
      const padding = 20;

      if (this.mobileView) {
        let top = this.posY;
        if (top + dlgHeight + padding > window.innerHeight)
          top = window.innerHeight - dlgHeight - padding;

        return 'margin:' + top + 'px auto';
      }

      let left = this.posX;
      if (left + dlgWidth + padding > window.innerWidth) {
        left = window.innerWidth - dlgWidth - padding;
      }

      let top = this.posY;
      if (top + dlgHeight + padding > window.innerHeight) {
        top = window.innerHeight - dlgHeight - padding;
      }

      const s = ';left:' + left + 'px; top:' + top + 'px';
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    },

    getDescriptionLength() {
      return (
        (this.task.description ? this.task.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
  },

  methods: {
    openModal(event) {
      this.posX = event.clientX;
      this.posY = event.clientY;
      this.$refs.dialog.openModal(event);
    },

    cancelModal() {
      console.error('cancelModal');
      this.$refs.dialog.closeModal();
      this.$emit('cancel');
    },

    closeModal() {
      this.$refs.dialog.closeModal();
    },
    onSave() {
      this.task.title.trim();
      if (this.task.title.length == 0) {
        this.invalidTitle = true;
        return;
      }
      if (this.editMode) {
        this.$store.dispatch('updateTask', this.task);
      } else {

        const userId = this.poll.user.id;
        this.task.user_id = userId;
        this.task.poll_id = this.poll.id;
        console.log('Add tasks:', this.task);        
        if( userId == null ) {
          alert('Only admin users can create tasks');
          return;
        }
        this.$store.dispatch('addTask', this.task);
      }
      this.task = new Task();
      this.$refs.dialog.closeModal();
      this.$emit('ok');
    },
  },

  updated() {
    this.modalDialog = this.$refs.dialog;
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

input.tasks-cont {
  width: 50px;
}
</style>